module.exports = __webpack_public_path__ + "img/led_xq.bcd189ef.png";